var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, OnInit } from '@angular/core';
import { SwipeDirection } from '../../directives/rm-swiper.directive';
import { HasSubscriptions } from '../../../components/has-subscriptions';
import { StaticPathPipe } from '../../pipes/static-path.pipe';
var RmCarouselComponent = /** @class */ (function (_super) {
    __extends(RmCarouselComponent, _super);
    function RmCarouselComponent(staticPathPipe) {
        var _this = _super.call(this) || this;
        _this.staticPathPipe = staticPathPipe;
        _this._images = [];
        _this._currentSlideIndex = 0;
        _this.visibleImages = [];
        _this.shouldPrefetch = false;
        _this.prefetchOffset = 3;
        _this.isSelectedCarousel = true;
        _this.isRedesign = false;
        _this.isNextCarousel = false;
        _this.carouselParentName = '';
        _this.isLuxury = false;
        _this.isListingDetails = false;
        _this.isCommercial = false;
        _this.showHighDprImages = false;
        _this.imageQualityPercentage = 10;
        _this.onSwipeCarousel = new EventEmitter();
        _this.onImageClick = new EventEmitter();
        _this.onChangeCarouselIndex = new EventEmitter();
        // Minimum movement needed before we take a swipe action as moving the images on the carousel
        _this._thresholdForHorizontalSwiping = 30;
        return _this;
    }
    Object.defineProperty(RmCarouselComponent.prototype, "images", {
        set: function (images) {
            this.visibleImages = [];
            this._images = Array.from(images);
            this.imageCount = images.length;
            this.updateVisibleImages();
        },
        enumerable: true,
        configurable: true
    });
    // this function will remove the first image from the _images[] and push to the visibleImages[]
    RmCarouselComponent.prototype.updateVisibleImages = function () {
        var i = 0;
        if (this.shouldPrefetch) {
            var t = Math.min(this._currentSlideIndex + this.prefetchOffset, this._images.length);
            while (i < t) {
                if (!this._images.length)
                    break;
                this.visibleImages.push(this._images.shift());
                i++;
            }
        }
        else {
            this.visibleImages[this._currentSlideIndex] = this._images[this._currentSlideIndex];
        }
    };
    Object.defineProperty(RmCarouselComponent.prototype, "currentSlideIndex", {
        get: function () {
            return this._currentSlideIndex;
        },
        set: function (i) {
            if (this._currentSlideIndex !== i) {
                this._currentSlideIndex = i;
                this.updateVisibleImages();
            }
        },
        enumerable: true,
        configurable: true
    });
    RmCarouselComponent.prototype.ngOnInit = function () {
        if (this.isCommercial) {
            this.placeHolderImage = '/assets/listing-default-image/commercial_placeholder@1x.svg';
        }
        else if (this.isLuxury) {
            this.placeHolderImage = '/assets/listing-default-image/luxury_placeholder@1x.svg';
        }
        else {
            this.placeHolderImage = '/assets/listing-default-image/residential_placeholder@1x.svg';
        }
    };
    RmCarouselComponent.prototype.nextSlide = function ($event) {
        $event.preventDefault();
        $event.stopImmediatePropagation();
        $event.stopPropagation();
        this.currentSlideIndex = this.currentSlideIndex === this.imageCount - 1 ? 0 : this.currentSlideIndex + 1;
        this.onChangeCarouselIndex.emit(this.currentSlideIndex);
        this.updateVisibleImages();
    };
    RmCarouselComponent.prototype.prevSlide = function ($event) {
        $event.preventDefault();
        $event.stopImmediatePropagation();
        $event.stopPropagation();
        this.currentSlideIndex = this.currentSlideIndex === 0 ? this.imageCount - 1 : this.currentSlideIndex - 1;
        this.onChangeCarouselIndex.emit(this.currentSlideIndex);
        this.updateVisibleImages();
    };
    RmCarouselComponent.prototype.swipeCarousel = function (event) {
        if (event.swipeEvent.type === 'touchend') {
            if (Math.abs(event.x.current - event.x.start) < (this._thresholdForHorizontalSwiping)
                || (Math.abs(event.y.current - event.y.start) > this._thresholdForHorizontalSwiping))
                return;
            if (event.x.direction === SwipeDirection.LEFT)
                this.nextSlide(event.swipeEvent);
            else
                this.prevSlide(event.swipeEvent);
        }
    };
    RmCarouselComponent.prototype.imgErrorHandler = function (event) {
        var image = this.staticPathPipe.transform(this.placeHolderImage);
        event.target.setAttribute('url', image);
        event.target.setAttribute('data-src', image);
        event.target.setAttribute('data-srcset', image);
        event.target.setAttribute('srcset', image);
        event.target.setAttribute('src', image);
    };
    RmCarouselComponent.prototype.trackFn = function (index, item) {
        return item;
    };
    return RmCarouselComponent;
}(HasSubscriptions));
export { RmCarouselComponent };
